// src/components/modal/ModalFooter.tsx

import React, { ReactNode } from 'react';

interface ModalFooterProps {
  children?: ReactNode;
  className?: string;
}

function ModalFooter({
  children,
  className = '',
}: ModalFooterProps) {
  return (
    <div
      className={`
        flex items-center justify-end gap-3
        border-t px-5 py-4
        ${className}
      `}
    >
      {children}
    </div>
  );
}

export default ModalFooter;